if (!window.customElements.get('custom-subscribe-accordion-picker')) {
  window.customElements.define(
    'custom-subscribe-accordion-picker',
    class CustomSubscribeAccordionPicker extends window.HTMLElement {
      connectedCallback() {
        this.initDOMElements();
        this.boundHandleChange = this.handleChange.bind(this);
        this.boundHandleKeydown = this.handleKeydown.bind(this);
        this.initEventListeners();
        this.updateUI();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }

      initDOMElements() {
        this.form = this.querySelector('form');
        this.cards = this.querySelectorAll('.subscribe-accordion-picker__card');
        this.addToCartButton = this.querySelector('#add-to-cart-button');
        this.addToCartPrice = this.querySelector('#add-to-cart-subscription-price');
        this.addToCartCompareAtPrice = this.querySelector('#add-to-cart-compare-at-price');
        this.addToCartCompareSep = this.querySelector('#add-to-cart-compare-sep');
        this.buyOnceLink = this.querySelector('#subscribe-accordion-buy-once');
        this.enableGtmTracking = this.dataset.enableGtmTracking === 'true';
      }

      initEventListeners() {
        this.form?.addEventListener('change', this.boundHandleChange);
        this.cards.forEach((card) => {
          card.addEventListener('keydown', this.boundHandleKeydown);
        });
      }

      removeEventListeners() {
        this.form?.removeEventListener('change', this.boundHandleChange);
        this.cards.forEach((card) => {
          card.removeEventListener('keydown', this.boundHandleKeydown);
        });
      }

      handleChange() {
        this.updateUI();
      }

      handleKeydown(event) {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }

        const radio = event.currentTarget.querySelector('input[type="radio"]');

        if (!radio) {
          return;
        }

        event.preventDefault();
        radio.checked = true;
        this.updateUI();
      }

      updateUI() {
        const selectedVariant = this.getSelectedVariant();

        if (!selectedVariant) {
          return;
        }

        this.updateCardStates(selectedVariant);
        this.updateMainButton(selectedVariant);
        this.updateBuyOnceLink(selectedVariant);
      }

      updateCardStates(selectedVariant) {
        this.cards.forEach((card) => {
          const radio = card.querySelector('input[type="radio"]');
          const isSelected = radio === selectedVariant;

          card.classList.toggle('is-selected', isSelected);
          card.classList.toggle('is-collapsed', !isSelected);
          card.setAttribute('aria-expanded', isSelected ? 'true' : 'false');
        });
      }

      updateMainButton(selectedVariant) {
        const data = selectedVariant.dataset;

        if (this.addToCartButton && data.checkoutUrl) {
          this.addToCartButton.href = this.appendTrackingParams(data.checkoutUrl);
        }

        if (this.addToCartPrice) {
          this.addToCartPrice.textContent = data.ctaPrice || '';
        }

        if (this.addToCartCompareAtPrice) {
          const comparePrice = data.ctaComparePrice || '';

          if (comparePrice && comparePrice !== data.ctaPrice) {
            this.addToCartCompareAtPrice.textContent = comparePrice;
            this.addToCartCompareAtPrice.classList.remove('hidden');
            this.addToCartCompareSep?.classList.remove('hidden');
          } else {
            this.addToCartCompareAtPrice.classList.add('hidden');
            this.addToCartCompareSep?.classList.add('hidden');
          }
        }
      }

      updateBuyOnceLink(selectedVariant) {
        if (!this.buyOnceLink) {
          return;
        }

        const data = selectedVariant.dataset;
        const buyOnceText = data.buyOnceText || '';
        const buyOnceUrl = data.buyOnceUrl || '';

        this.buyOnceLink.textContent = buyOnceText;

        if (this.buyOnceLink.tagName === 'A') {
          if (buyOnceUrl) {
            this.buyOnceLink.href = this.appendTrackingParams(buyOnceUrl);
            this.buyOnceLink.classList.remove('hidden');
          } else {
            this.buyOnceLink.classList.add('hidden');
          }
        }
      }

      getSelectedVariant() {
        return this.form?.querySelector('input[type="radio"]:checked');
      }

      appendTrackingParams(url) {
        if (!this.enableGtmTracking || !url || !window.SeranovaTracking) {
          return url;
        }

        return window.SeranovaTracking.appendParams(url);
      }
    },
  );
}
